import { Card } from "@/components/ui/card/Card";
import { WORKING_CARDS } from "./constants";
import type { WorkingCardVariant } from "./types";

const cardContainerStyles: Record<WorkingCardVariant, string> = {
  highlight: "bg-[#101828] border-none shadow-md",
  default: "bg-white border border-gray-100 hover:shadow-xs",
  success: "bg-white border border-gray-100 hover:shadow-xs",
};

const labelStyles: Record<WorkingCardVariant, string> = {
  highlight: "text-gray-400 font-normal text-xs sm:text-sm",
  default: "text-gray-400 font-normal text-xs sm:text-sm",
  success: "text-gray-400 font-normal text-xs sm:text-sm",
};

const valueStyles: Record<WorkingCardVariant, string> = {
  highlight: "text-white font-semibold text-2xl sm:text-[28px] tracking-tight",
  default:
    "text-text-primary font-semibold text-2xl sm:text-[28px] tracking-tight",
  success:
    "text-green-600 font-semibold text-2xl sm:text-[28px] tracking-tight",
};

export function WorkingsInsight() {
  return (
    <section
      id="workings-insight"
      className="w-full max-w-7xl mx-auto px-5 md:px-8 py-20 sm:py-28 flex flex-col gap-12 sm:gap-16"
    >
      {/* Heading Block */}
      <div className="flex flex-col gap-3.5 justify-center items-center text-center">
        <h2 className="text-3xl sm:text-5xl font-normal text-text-primary tracking-tight leading-tight">
          One number. Backed by the workings.
        </h2>
        <p className="text-base sm:text-lg text-text-secondary leading-relaxed max-w-2xl">
          The Safe-to-Spend figure is the headline. The proof is always visible
          underneath.
        </p>
      </div>

      {/* Grid Block */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {WORKING_CARDS.map((card) => (
          <Card
            key={card.label}
            as="article"
            hoverable
            className={`p-6 sm:p-8 flex flex-col items-start gap-2.5 w-full select-none ${
              cardContainerStyles[card.variant]
            }`}
          >
            {/* Label */}
            <span className={labelStyles[card.variant]}>{card.label}</span>
            {/* Value */}
            <span className={valueStyles[card.variant]}>{card.value}</span>
          </Card>
        ))}
      </div>
    </section>
  );
}

export default WorkingsInsight;
